import React, { useState } from 'react';
import { Bell, ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const SEVERITY = {
    high: { dot: 'bg-red-500', chip: 'bg-red-50 border-red-200' },
    medium: { dot: 'bg-amber-500', chip: 'bg-amber-50 border-amber-200' },
    low: { dot: 'bg-gray-400', chip: 'bg-gray-50 border-gray-200' },
};

/**
 * What happened, which buyer, and what to do about it.
 */
export default function AgentAlerts({ alerts = [], onBuyerClick, buyersByKey = {} }) {
    const [expanded, setExpanded] = useState(false);
    if (!alerts.length) {
        return (
            <p className="rounded-xl border border-dashed border-gray-200 p-6 text-center text-sm text-gray-500">
                Nothing needs your attention on this campaign right now.
            </p>
        );
    }

    const visible = expanded ? alerts : alerts.slice(0, 6);

    return (
        <div className="space-y-2">
            {visible.map((alert, index) => {
                const style = SEVERITY[alert.severity] || SEVERITY.low;
                const buyer = alert.buyer_key ? buyersByKey[alert.buyer_key] : null;
                return (
                    <div key={`${alert.type}-${index}`} className={`rounded-xl border p-3 ${style.chip}`}>
                        <div className="flex items-start gap-2.5">
                            <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${style.dot}`} />
                            <div className="min-w-0">
                                <p className="text-sm font-bold text-[#374151]">{alert.title}</p>
                                <p className="text-xs text-gray-600">{alert.detail}</p>
                                <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-[#3a99a3]">
                                    <ArrowRight size={12} /> {alert.action}
                                </p>
                            </div>
                            {buyer && onBuyerClick && (
                                <button
                                    type="button"
                                    onClick={() => onBuyerClick(buyer)}
                                    className="mt-0.5 shrink-0 rounded-lg border border-gray-200 bg-white px-2.5 py-1 text-xs font-semibold text-[#374151] hover:border-[#55C5D0]"
                                >
                                    Act on it
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}

            {alerts.length > 6 && (
                <button
                    type="button"
                    onClick={() => setExpanded((prev) => !prev)}
                    className="flex w-full items-center justify-center gap-1 rounded-lg border border-gray-200 py-2 text-sm font-semibold text-[#3a99a3] hover:bg-[#f0fafb]"
                >
                    {expanded
                        ? (<><ChevronUp size={14} /> Show fewer alerts</>)
                        : (<><ChevronDown size={14} /> Show all {alerts.length} alerts</>)}
                </button>
            )}

            <p className="flex items-center gap-1 pt-1 text-[11px] text-gray-400">
                <Bell size={11} /> Alerts are recalculated every time you open this tab.
            </p>
        </div>
    );
}
